module.exports = __webpack_public_path__ + "img/benetton-rugby-logo-icon.8a8fc69f.png";